<template>
  <div class="auth-page">
    <div class="background-image">
      <img src="/images/car.jpeg" alt="Car" />
    </div>
    <div class="auth-sidebar" id="auth-sidebar">
      <div class="auth-container">
        <div class="logo text-center">
          <img src="/images/lga-logo.png" alt="LGA logo" />
        </div>
        <hr />
        <h1>Reset Password</h1>
        <p>
          Please enter your email address and we will send you a link to reset
          your password.
        </p>

        <div class="alert alert-danger" v-if="form.errors.has('email')">
          <h4>Error!</h4>
          <p>Sorry, the following errors occurred:</p>
          <ul>
            <li
              v-bind:key="index"
              v-for="(error, index) in form.errors.all()"
              v-text="error[0]"
            ></li>
          </ul>
        </div>

        <div class="alert alert-success" v-if="completed">
          <h4>Success!</h4>
          <p class="mb-0">Please check your email.</p>
        </div>

        <form>
          <inputbox
            name="email"
            :stacked="false"
            label="Email Address"
            placeholder="email@example.com"
            v-model="form.email"
            type="email"
            :show-error="form.errors.has('email')"
            :error-message="form.errors.get('email')"
          ></inputbox>

          <div class="row">
            <div class="col-lg-6">
              <form-button :indicator="indicator" v-on:clicked="request"
                >Send Request</form-button
              >
            </div>
            <div class="col-lg-6">
              <router-link to="/login" class="text-right small forgot-password"
                >Back to login</router-link
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Form from './../../Classes/Form';

export default {
  data() {
    return {
      form: new window.Form({
        email: null
      }),
      completed: false,
      indicator: false
    };
  },

  mounted() {
    new window.Ps(document.getElementById('auth-sidebar'));
  },

  methods: {
    request() {
      this.indicator = true;

      this.form
        .post('/forgot-password')
        .then(response => {
          this.handleSuccessResponse(response);
        })
        .catch(error => {
          this.handleErrorResponse(error);
        });
    },

    handleSuccessResponse(response) {
      this.completed = true;
      this.disableIndicator();
    },

    handleErrorResponse(error) {
      if (error.error === 'Invalid credentials') {
        window.toastify.error('Sorry, there was an issue making the request');
      }
      this.disableIndicator();
    },

    disableIndicator() {
      this.indicator = false;
    }
  }
};
</script>
